import { DateTime as LuxonDatetime }  from 'luxon';


import * as am4core from "@amcharts/amcharts4/core";
import * as am4plugins_annotation from "@amcharts/amcharts4/plugins/annotation";
import * as am4charts from "@amcharts/amcharts4/charts";

export const am4ChartMixin = {
    methods: {
        // Create Am4 Chart
        am4CreateChart(name, type) {
            return am4core.create(name, type)
        },

        // Setup Chart Configuration
        am4SetupChartConfiguration(chart, formatter, frequencyToReload) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            chart.svgContainer.autoResize = false
            chart.dateFormatter = formatter
            chart.preloader.delay = 2000
            chart.preloader.disabled = true
            chart.cursor = new am4charts.XYCursor()
        },

        // Add in am4 chart plugins
        am4SetupChartPlugins(chart) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            chart.exporting.menu = new am4core.ExportMenu();
            chart.exporting.filePrefix = this.fileName
            chart.exporting.adapter.add('filePrefix', (filePrefix) => {
                filePrefix.filePrefix = this.fileName
                return filePrefix
            })
            chart.exporting.dateFormat = 'i'

            if (this.permissions.can('can_export_point_data')) {
                chart.exporting.menu.items[0].menu.push({
                    label: 'Export Data',
                    type: 'custom',
                    options: {
                        callback: () => {
                            this.exportData()
                        }
                    },
                })
            }

            chart.exporting.menu.events.on('hit', event => {
                if (!_.isNil(event.branch) && !_.isNil(event.branch.type) && event.branch.type !== 'annotate') {
                    if (window.fathomLoaded) {
                        window.fathom.trackGoal('K8TLPFJF', 0)
                    }
                }
            })
            chart.plugins.push(new am4plugins_annotation.Annotation());
        },
        am4SetupChartTitle(chart) {
            /**
             * At the request of CIPLA (Indian Pharmaceutical Company) we are doing the following custom development
             *   - We are adding a title to the chart when the export starts
             *   - That title will include a summary of the point's header information
             *     - Point Name
             *     - Start Date
             *     - End Date
             *     - User who exported the graph image.
             */
            chart.exporting.events.on("exportstarted", () => {
                this.chartTitle = this._getChartTitleText()
                this._addTitleToChart(chart)
            })
            chart.exporting.events.on('exportfinished', () => {
                this.chartTitle = "";
                chart.titles.clear()
            })
        },

        _addTitleToChart(chart) {
            let title = chart.titles.create()
            title.adapter.add('text', (text) => {
                // return this._getChartTitleText()
                return this.chartTitle
            })
            title.fontSize = 20
            title.marginBottom = 15
            title.align = 'center'
            title.textAlign = 'center'
        },

        _getChartTitleText() {
            // Build luxon datetime objects from startDate and endDate
            let startDate = LuxonDatetime.fromJSDate(this.startDate, {zone: this.companyTimezone})
            let endDate = LuxonDatetime.fromJSDate(this.endDate, {zone: this.companyTimezone})

            // Build Title as PointName - StartDate to EndDate
            let title = `${this.name}; starting at ${startDate.toFormat('MM-dd-yyyy HH:mm:ss')}`
            title += ` and ending at ${endDate.toFormat('MM-dd-yyyy HH:mm:ss')};`
            title += `\nExported by ${this.username} on ${LuxonDatetime.local().toFormat('MM-dd-yyyy HH:mm:ss')}`
            return title
        },

        // Check if a chart is invalid
        _am4ChartInvalid(chart) {
            return !_.isNil(chart)
        },
    },
}